<div class="m-grid__item m-grid__item--fluid m-wrapper">
    <router-outlet></router-outlet>
</div>
